import { render, staticRenderFns } from "./materialInventory.vue?vue&type=template&id=2c82222e&"
import script from "./materialInventory.vue?vue&type=script&lang=js&"
export * from "./materialInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports